import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { Tooltip } from 'components/Tooltip';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

interface PortType {
  color?: string;
  borderColor?: string;
  position: { x: number; y: number };
}

const Port: FC<PortType> = ({ color, borderColor, position }) => (
  <Box
    style={{
      width: '16px',
      height: '16px',
      position: 'absolute',
      borderRadius: '50%',
      transform: 'translate(-8px,-8px)',
      backgroundColor: color || '#DADFE4',
      border: '2px solid #c2c5d3',
      borderColor: borderColor || '#C1C8D0',
      left: position.x * 96,
      top: position.y * 96
    }}
  />
);

interface IFlowComponentProps {
  displayName?: string;
  category?: string;
  type?: string;
  description?: string;
  icon?: string;
  ports?: {};
  isEditable: boolean;
  fnDragStart?: (e: any) => void;
}

const FlowComponent: FC<IFlowComponentProps> = ({
  type,
  displayName,
  category,
  ports,
  isEditable,
  fnDragStart,
  icon,
  description
}) => {
  const trimChars = (maxChars: number, chars?: string) =>
    chars?.substring(0, maxChars).concat(chars?.length > maxChars ? '...' : '');

  const svgWrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (svgWrapperRef.current && icon) {
      svgWrapperRef.current.innerHTML = icon;
    }
  }, []);

  return (
    <Tooltip content={description} direction="top" bgColor="#ffffe6" color="black">
      <FlexLayout
        boxShadow="subtle"
        borderRadius="small"
        bg="white"
        border="regular"
        flexDirection="column"
        alignItems="center"
        position="relative"
        justifyContent="center"
        borderColor="secondary"
        style={{
          width: '96px',
          height: '96px',
          cursor: 'move',
          transform: 'translate(0, 0)',
          boxSizing: 'border-box'
        }}
        draggable={isEditable}
        onDragStart={fnDragStart}
      >
        <Box ref={svgWrapperRef} />

        <FlexLayout flexDirection="column" alignItems="center">
          <H4 fontWeight="semiBold" fontSize="xs" style={{ textTransform: 'uppercase' }}>
            {trimChars(9, displayName || type)}
          </H4>
          <H4
            textAlign="center"
            fontWeight="semiBold"
            fontSize="xs"
            color="secondary"
            style={{ textTransform: 'uppercase' }}
          >
            {trimChars(10, category)}
          </H4>
        </FlexLayout>

        {ports && Object.keys(ports).map(p => <Port key={p} {...ports[p]} />)}
      </FlexLayout>
    </Tooltip>
  );
};

export default FlowComponent;
